var AuthFormOnetimePasswordStart = ( function($) {

    var AuthFormOnetimePasswordStart = function(options) {
        this.init(options);
    };

    var Self = AuthFormOnetimePasswordStart;
    Self.className = 'AuthFormOnetimePasswordStart';
    var Parent = ActionformAbstract;

    var def = ActionformAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;
        Parent.prototype.init.call(that, options);
    };

    Self.prototype.initVars = function (options) {
        var that = this;

        options = options || {};

        that.selectors = {
            form: '.js-form-onetime-password-start',
            next_action: '.js-form-onetime-password-login',
            previous_action: '',

            next_action_sent_to: '.js-sent-to',
            next_action_login_input: '.js-login',
            next_action_cid_input: '.js-cid', // contact id, on signup only
            next_action_code_request_timelimit: '.js-request-code-timelimit',
        };

        that.data_keys = {
            next_action_next_code_time_limit: 'time-limit',
        };

        that.url = $.sa.build_url('auth/onetime-password/send');
        that.method = 'POST';

        that.has_success_screen = false;

        // TODO: code could be onetime password or confirmation code; need different keys?
        // to save data in the local storage, when not in modal mode (next action is separate page e.g.)
        that.next_action_data_key_prefix = 'avia/auth-onetime-pwd';

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.initNextAction = function ($action) {
        var that = this;

        Parent.prototype.initNextAction.call(that, $action);

        that.$next_action_sent_to = that.$next_action.find(that.selectors.next_action_sent_to);
        that.$next_action_login_input = that.$next_action.find(that.selectors.next_action_login_input);
        that.$next_action_cid_input = that.$next_action.find(that.selectors.next_action_cid_input);
        that.$next_action_code_request_timelimit = that.$next_action.find(that.selectors.next_action_code_request_timelimit);
    };

    Self.prototype.onActionShown = function () {
        // do not clear the form on show
        return true;
    };

    Self.prototype.beforeMoveToNextAction = function (response) {
        var that = this,
            data = (response && response.data) || {};

        // set `sent_to`, `login` and `next_code_time` values
        // (in modal mode it should be made after next action was shown)
        that.__saveNextActionData(data);
    };

    Self.prototype.onDoneSubmitHandleSuccess = function (response) {
        var that = this,
            data = (response && response.data) || {},
            next_action = data.next_action || '',
            next_action_selector,
            $next_action;

        if (next_action) {
            next_action_selector = that._getSelectorByActionName(next_action);
            $next_action = that.isModalMode()
                ? that.$modal_content.find(next_action_selector)
                : $.sa.$document.find(next_action_selector);

            if (next_action_selector && $next_action && $next_action.length) {
                that.selectors.next_action = next_action_selector;
                that.initNextAction($next_action);
            }
        }

        Parent.prototype.onDoneSubmitHandleSuccess.call(that, response);
    };

    Self.prototype.showErrors = function (errors) {
        errors = errors || [];

        var that = this,
            // "out of limit code requests" error
            request_limit_error_index = errors.findIndex(er => er.code == 1104), // if someday we won't need to display that error, we could delete that error from the `errors` by index
            login_blocked_error_index = errors.findIndex(er => er.code == 1102);

        if (-1 !== request_limit_error_index || -1 !== login_blocked_error_index) {
            that.toggleSubmitButtonAvailability(false);
            // if someday we won't need to display that error, uncomment next line, and remove previous line
            // errors.splice(request_limit_error_index, 1);
        }
        Parent.prototype.showErrors.call(that, errors);
    };

    Self.prototype.needRedirect = function () {
        var that = this;

        // always move to the next screen, even in non-modal mode
        return false;
    };
    
    Self.prototype.needGoToNext = function () {
        var that = this;

        // always move to the next screen, even in non-modal mode
        return true;
    };

    Self.prototype._getSelectorByActionName = function (action) {
        var that = this;

        action = action.toString().toLowerCase();

        switch (action) {
            case 'login':
                return '.js-form-onetime-password-login';
            case 'signup':
            case 'signup_confirm':
            case 'confirm_login':
            case 'confirm_email':
            case 'confirm_phone':
                return '.js-form-onetime-password-signup';
            default:
                return '';
        }
    };

    Self.prototype.__saveNextActionData = function (data) {
        var that = this;

        if (that.needGoToNext()) {
            that.__saveNextActionDataModalMode(data);
        }
        else {
            that.__saveNextActionDataNotModalMode(data);
        }
    };

    Self.prototype.__saveNextActionDataModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            cid = data.cid || '', // contact id
            next_code_time = data.next_code_time || 0;

        // in modal mode, save values into DOM elements
        that.$next_action_sent_to.text(sent_to);
        that.$next_action_login_input.val(login);
        that.$next_action_cid_input.val(cid);
        that.$next_action_code_request_timelimit
            .attr('data-' + that.data_keys.next_action_next_code_time_limit, next_code_time);
    };

    Self.prototype.__saveNextActionDataNotModalMode = function (data) {
        var that = this,
            sent_to = data.sent_to || '',
            login = data.login || '',
            cid = data.cid || '', // contact id
            next_code_time = data.next_code_time || 0,
            key_prefix = that.next_action_data_key_prefix + '-';

        // not in modal mode (if next action is on separate page e.g.), save data into local storage
        sessionStorage.setItem(key_prefix + 'login', login);
        sessionStorage.setItem(key_prefix + 'cid', cid);
        sessionStorage.setItem(key_prefix + 'sent-to', sent_to);
        sessionStorage.setItem(key_prefix + 'next-request-timelimit', next_code_time);
    };

    return Self;
})(jQuery);